export const LogoMark = ({ size = 40, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    data-testid="logo-mark"
  >
    <rect width="100" height="100" rx="20" fill="#12141C" />
    <path
      d="M50 15L59.5 38.5L85 41.5L65 58.5L71 83.5L50 70L29 83.5L35 58.5L15 41.5L40.5 38.5L50 15Z"
      fill="#FF2A3B"
    />
    <circle cx="50" cy="50" r="8" fill="#0A0B0E" />
    <path
      d="M50 25L54 40L68 42L57 51L60 66L50 58L40 66L43 51L32 42L46 40L50 25Z"
      fill="#FFF"
      opacity="0.9"
    />
  </svg>
);

export const LogoFull = ({ size = 44 }) => (
  <div className="flex items-center gap-3" data-testid="logo-full">
    <LogoMark size={size} />
    <div className="leading-none">
      <div className="font-display font-bold tracking-tight text-white text-2xl">
        RED STAR
      </div>
      <div className="font-jbmono text-[11px] tracking-[0.32em] text-[#FF2A3B] uppercase">
        Solutions
      </div>
    </div>
  </div>
);
